<template>
  <div class="w-100">
    Appointment CANCEL SMS for
    <appointment-object :appointment-number="appointmentNumber()" />

    sent to job contact
    <customer-object
      :entity-id="customerId()"
      :name="contactName()"
      :open-new="true"
      :tooltip="contactProfile()"
    />

    <message-object :tooltip="messageContent()" />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
